import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { Col, Image, Link, Row } from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { bestDealClick } from 'reaxl-analytics-handlers';
import { Tip } from 'reaxl-molecules';

import getPathSRP from '@/utilities/getPathSRP';

import { queryDuck } from '@/ducks';

const renderTipBody = (path = '', onEntryPointClick = () => { }) => (
    <>
        <Link
            className="link-undecorated text-bold"
            href={path}
            onClick={onEntryPointClick}
        >
            <Row
                className="display-flex align-items-center"
            >
                <Col
                    className="text-left text-sm-right padding-horizontal-0"
                    xs={1}
                    sm={2}
                >
                    <Image
                        alt="KBB logo"
                        height={42}
                        src="/content/static/img/icon/logos/kbb-logo-notext.svg"
                        width="auto"
                    />
                </Col>
                <Col
                    xs={11}
                    sm={10}
                >
                    Shop Best Deals
                </Col>
            </Row>
        </Link>
        <Row>
            <Col
                className="padding-right-1"
                xs={11}
                xsOffset={1}
                sm={10}
                smOffset={2}
            >
                As prices change, know that you&apos;re getting the
                <b> best deals </b>
                with Kelley Blue Book® Price Advisor.
            </Col>
        </Row>
    </>
);

function BestDealsFilterEntryPoint({
    className,
}) {

    const query = useSelector(queryDuck.selectors.getDuckState);
    const [path, setPath] = useState('');

    const handleEntryPointClick = async (e) => {
        e.preventDefault();
        sendClick(bestDealClick);
        window.location.href = path;
    };

    useEffect(() => {

        const generateFilterEntryPointPath = async () => {
            const bonnetPath = await getPathSRP({ ...query, experience: 'best-deals' }, { basePath: true });
            setPath(bonnetPath);
        };

        generateFilterEntryPointPath();
    }, [query]);

    return (
        <div
            className={className}
            data-cmp="best-deals-srp-filter-entry-point"
        >
            <Tip
                body={renderTipBody(path, handleEntryPointClick)}
                className="rounded padding-horizontal-4"
                borderColor="info-200"
                backgroundColor="info-100"
            />
        </div>
    );
}

export default BestDealsFilterEntryPoint;
